<div
	[formGroup]="formParams"
	class="zk-flex zk-flex-wrap zk-mb-4 zk-gap-4 billing-data"
	*ngIf="formParams"
>
	<div class="zk-w-full" *ngIf="showTitle">
		<h1
			class="zk-text-base text-color zk-font-thick"
			*ngIf="formParams.get('businessFiscalId')"
		>
			{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.TITLE_PJ' | translate }}
		</h1>
		<h4
			class="zk-mt-2 billing-subtitle"
			*ngIf="formParams.get('businessFiscalId')"
		>
			{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.SUBTITLE_PJ' | translate }}
		</h4>
		<h1
			class="zk-text-base text-color zk-font-thick"
			*ngIf="!formParams.get('businessFiscalId')"
		>
			{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.TITLE_PF' | translate }}
		</h1>
	</div>

	<!--Legal person form-->
	<app-company-validation
		(waitingIdwallResponse)="isIdwallCalled($event)"
		(cpnjValidationTrigger)="cpnjValidationTrigger.emit($event)"
		[formParams]="formParams"
		[professionalPerson]="professionalPerson"
	></app-company-validation>

	<!-- Natural person form-->
	<div *ngIf="!formParams.get('businessFiscalId')" class="zk-w-full">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="isFieldInvalid(formParams, 'fiscalId') ? 'error' : 'default'"
		>
			<input
				id="billing-fiscal-id"
				zkInputRef
				[mask]="'000.000.000-00'"
				formControlName="fiscalId"
				placeholder="{{
					'MY_ACCOUNT.FINANCIAL.BILLING_DATA.FISCAL_ID' | translate
				}}"
			/>
			<span zkInputLabel
				>{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.FISCAL_ID' | translate }}
			</span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'fiscalId')"
			>
				<ng-container *ngIf="!formParams.get('fiscalId').value">
					{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.FISCAL_ID' | translate }}
				</ng-container>
				<ng-container *ngIf="formParams.get('fiscalId').value">
					{{
						'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.FISCAL_ID_INVALID'
							| translate
					}}
				</ng-container>
			</span>
		</zk-input>
	</div>
	<div
		class="zk-w-full"
		*ngIf="
			formParams.get('nationalIdentityCard') &&
			!formParams.get('isForeign')?.value
		"
	>
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="
				isFieldInvalid(formParams, 'nationalIdentityCard') ? 'error' : 'default'
			"
		>
			<input
				id="billing-national-identity-card"
				zkInputRef
				formControlName="nationalIdentityCard"
				placeholder="{{
					'MY_ACCOUNT.FINANCIAL.BILLING_DATA.NATIONAL_IDENTITY_CARD' | translate
				}}"
			/>
			<span zkInputLabel
				>{{
					'MY_ACCOUNT.FINANCIAL.BILLING_DATA.NATIONAL_IDENTITY_CARD' | translate
				}}
			</span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'nationalIdentityCard')"
			>
				{{
					'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.NATIONAL_IDENTITY_CARD'
						| translate
				}}
			</span>
		</zk-input>
	</div>

	<div
		class="zk-w-full"
		*ngIf="formParams.get('rne') && formParams.get('isForeign').value"
	>
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="isFieldInvalid(formParams, 'rne') ? 'error' : 'default'"
		>
			<input
				id="billing-national-rne"
				zkInputRef
				formControlName="rne"
				placeholder="{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.RNE' | translate }}"
			/>
			<span zkInputLabel
				>{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.RNE' | translate }}
			</span>
			<span
				zkInputMessage
				[class.zk-hidden]="!isFieldInvalid(formParams, 'rne')"
			>
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.RNE' | translate }}
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full" *ngIf="!formParams.get('businessFiscalId')">
		<zk-input
			class="sm:zk-mt-1"
			[zkStatus]="isFieldInvalid(formParams, 'pis') ? 'error' : 'default'"
		>
			<input
				id="billing-pis"
				zkInputRef
				formControlName="pis"
				placeholder="{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.PIS' | translate }}"
			/>
			<span zkInputLabel
				>{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.PIS' | translate }}
			</span>
			<span
				zkInputMessage
				[innerHTML]="
					'MY_ACCOUNT.FINANCIAL.BILLING_DATA.PIS_DESCRIPTION' | translate
				"
			>
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full" *ngIf="formParams.get('ccm')">
		<zk-input class="sm:zk-mt-1" [zkStatus]="'default'">
			<input
				id="billing-ccm"
				zkInputRef
				formControlName="ccm"
				placeholder="{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.CCM' | translate }}"
			/>
			<span zkInputLabel
				>{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.CCM' | translate }}
			</span>
			<span zkInputMessage class="zk-pr-0">
				<div
					[innerHTML]="
						'MY_ACCOUNT.FINANCIAL.BILLING_DATA.CCM_DESCRIPTION' | translate
					"
				></div>
			</span>
		</zk-input>
	</div>

	<div class="zk-w-full" *ngIf="formParams.get('serviceCode')">
		<zk-dropdown
			class="sm:zk-mt-1"
			id="billing-service-code"
			[label]="'MY_ACCOUNT.FINANCIAL.BILLING_DATA.SERVICE_CODE' | translate"
			[multiple]="true"
			[disabled]="formParams.get('serviceCode').disabled"
			[placeholder]="
				'MY_ACCOUNT.FINANCIAL.BILLING_DATA.SERVICE_CODE_PLACEHOLDER' | translate
			"
			formControlName="serviceCode"
			[options]="serviceCodeOptions"
			[zkStatus]="
				isFieldInvalid(formParams, 'serviceCode') ? 'error' : 'default'
			"
		></zk-dropdown>
		<div
			class="zk-text-left zk-text-xs zk-mt-1 zk-px-4"
			*ngIf="!isFieldInvalid(formParams, 'serviceCode')"
		>
			{{
				'MY_ACCOUNT.FINANCIAL.BILLING_DATA.SERVICE_CODE_DESCRIPTION' | translate
			}}
		</div>
		<div
			class="zk-text-left zk-text-xs zk-mt-1 zk-px-4 zk-text-error"
			*ngIf="isFieldInvalid(formParams, 'serviceCode')"
		>
			<ng-container *ngIf="formParams.get('serviceCode').value?.length === 0">
				{{
					'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.SERVICE_CODE_REQUIRED'
						| translate
				}}
			</ng-container>
			<ng-container *ngIf="formParams.get('serviceCode').value?.length > 3">
				{{ 'MY_ACCOUNT.FINANCIAL.BILLING_DATA.ERROR.SERVICE_CODE' | translate }}
			</ng-container>
		</div>
	</div>
</div>
